import { createFileRoute } from '@tanstack/react-router';

import { DeviceDetailView } from '../../../features/devices/device-detail-view';
import { getCachedDeviceName } from '../../../features/devices/queries';

export const Route = createFileRoute('/admin/devices/$deviceAuthId')({
  staticData: {
    breadcrumb: (match, queryClient) => {
      const { deviceAuthId } = match.params as { deviceAuthId: string };
      return getCachedDeviceName(queryClient, deviceAuthId);
    },
  },
  component: AdminDeviceDetail,
});

function AdminDeviceDetail() {
  const { deviceAuthId } = Route.useParams();
  return <DeviceDetailView deviceAuthId={deviceAuthId} />;
}
